import mapStatsToLineChart from '../../utils/chartAdapter/lineChartAdapter';

const formatGraphData = (graphDataPoint, graphDate, translation) => {
    const {
        lead,
        impression,
    } = graphDataPoint || {};

    const graphDataPointLead = lead
        && lead.month
        && Object.keys(lead.month).length !== 0 ? lead.month : null;

    const graphDataPointImpression = impression
    && impression.month
    && Object.keys(impression.month).length !== 0 ? impression.month : null;

    const graphData = {};

    graphData.lead = graphDate
        && graphDataPointLead
        && graphDataPointLead.total
        ? mapStatsToLineChart(
            { total: graphDataPointLead.total },
            graphDate.month,
            'MONTH',
            translation,
        ) : null;

    graphData.impression = graphDate
        && graphDataPointImpression
        && graphDataPointImpression.total
        ? mapStatsToLineChart(
            { total: graphDataPointImpression.total },
            graphDate.month,
            'MONTH',
            translation,
        ) : null;

    return graphData;
};

export default formatGraphData;
